export const HOME_ROUTE = '/';
export const OWNER_LANDING_ROUTE = '/arrendamiento-para-propietarios';
export const OWNER_REGISTRATION_ROUTE = '/registro-propietario';
export const LEGACY_OWNER_REGISTRATION_ROUTE = '/publicar-propiedad';

export function buildOwnerRegistrationHref(search = '', hash = '') {
  return `${OWNER_REGISTRATION_ROUTE}${search || ''}${hash || ''}`;
}

export function resolveOwnerLandingBackTarget(currentPath: string) {
  try {
    const previousPath = window.sessionStorage.getItem('rc:lastAppPath');
    if (previousPath && previousPath !== currentPath) {
      return previousPath;
    }
  } catch {
    // Ignore storage failures and fall back to home.
  }

  return HOME_ROUTE;
}
